class ComponentIngredientopediaContent extends HTMLElement {
  constructor() {
    super()

    const self = this
    const letters = 'abcdefghijklmnopqrstuvwxyz'.split('')
    const letterSections = {}
    const letterButtons = {}

    function getScrollOffset() {
      const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0
      const stickyHeight = self.querySelector(".search-sticky").offsetHeight
      return headerHeight + stickyHeight
    }

    function scrollToElement(selector) {
      const el = document.querySelector(selector)
      if (!el) return
      const y = el.getBoundingClientRect().top + window.scrollY - getScrollOffset()
      window.scrollTo({ top: y })
    }

    let trapHandler = null

    function trapFocus(container) {
      const focusable = () => container.querySelectorAll('input, button, [tabindex]:not([tabindex="-1"])')
      trapHandler = function(e) {
        if (e.key !== 'Tab') return
        const els = focusable()
        if (!els.length) return
        const first = els[0], last = els[els.length - 1]
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus() }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus() }
      }
      container.addEventListener('keydown', trapHandler)
    }

    function removeTrapFocus(container) {
      if (trapHandler) container.removeEventListener('keydown', trapHandler)
      trapHandler = null
    }

    letters.forEach(function(letter) {
      letterSections[letter] = self.querySelector(`.segment.${letter}`)
      letterButtons[letter] = self.querySelector(`.scroll-button.${letter}`)
    })

    letters.forEach(function(letter) {
      if (letterSections[letter] == null) {
        letterButtons[letter].classList.add("disabled")
        letterButtons[letter].setAttribute("tabindex", "-1")
      } else {
        letterButtons[letter].addEventListener('click', function() {
          scrollToElement(`.letter-segment.${letter}`)
        })
      }
    })

    const searchResults = this.querySelector(".found-results")
    const searchContainer = this.querySelector(".search-container")
    const inputSearch = this.querySelector(".input-search")
    let focusTrapped = false

    const listedElements = this.querySelectorAll(".ingredient-listed")

    inputSearch.addEventListener('input', function(event) {
      addSearchResults(event.target.value)
    })

    searchContainer.addEventListener('keyup', function(event) {
      if (event.keyCode == 27) {
        hideResults()
      }
    })

    let currentLetter
    const stickyBar = self.querySelector(".search-sticky")

    window.addEventListener('scroll', function() {
      let found = false
      const offset = getScrollOffset()

      letters.forEach(function(letter) {
        if (letterSections[letter]) {
          const position = letterSections[letter].getBoundingClientRect()
          if (!found && position.top - offset >= 0 && position.bottom - offset <= window.innerHeight) {
            if (currentLetter != letter) {
              letterButtons[letter].parentNode.classList.add("active")
              if (currentLetter)
                letterButtons[currentLetter].parentNode.classList.remove("active")
              currentLetter = letter
            }
            found = true
          }
        }
      })
    })

    function handlerDocumentClick(evt) {
      if (!searchContainer.contains(evt.target)) {
        hideResults()
      }
    }

    function showResults() {
      searchResults.classList.add("visible")
      if (!focusTrapped) {
        focusTrapped = true
        trapFocus(searchContainer)
        document.addEventListener('click', handlerDocumentClick)
        inputSearch.focus()
      }
    }

    function hideResults(cleanValue = true) {
      searchResults.classList.remove("visible")
      if (focusTrapped) {
        focusTrapped = false
        removeTrapFocus(searchContainer)
        document.removeEventListener('click', handlerDocumentClick)
        if (cleanValue)
          inputSearch.value = ''
      }
    }

    function addSearchResults(inputValue) {
      searchResults.innerHTML = ""

      if (inputValue.length > 1) {
        const matches = []

        listedElements.forEach(function(listedElement) {
          if (listedElement.getAttribute("title").toLowerCase().includes(inputValue.toLowerCase()))
            matches.push(listedElement)
        })

        if (matches.length > 0) {
          const title = document.createElement('div')
          title.innerHTML = "Search Results"
          title.classList.add('visually-hidden')
          searchResults.appendChild(title)

          matches.forEach(function(listedElement) {
            const containerButton = document.createElement('div')
            containerButton.classList.add("search-button-container")
            const button = document.createElement('button')
            button.setAttribute("type", "button")
            button.innerHTML = listedElement.getAttribute("title")
            containerButton.appendChild(button)
            searchResults.appendChild(containerButton)

            button.addEventListener('click', function() {
              const handledTitle = listedElement.getAttribute("handled-title")
              const target = self.querySelector(`.ingredient-listed[handled-title=${handledTitle}]`)
              if (target) target.open = true
              scrollToElement(`.ingredient-listed[handled-title=${handledTitle}]`)
              hideResults()
            })
          })
          showResults()
        } else {
          hideResults(false)
        }
      } else {
        hideResults(false)
      }
    }
  }
}
customElements.define('ingredientopedia-content', ComponentIngredientopediaContent)
